<template>
    <Component :is="sliceVariationComponent" v-bind="props" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {FeaturesSlice} from '@prismicio-types';
    import FeaturesCentred from './variations/FeaturesCentred.vue';
    import FeaturesDefault from './variations/FeaturesDefault.vue';
    import FeaturesList from './variations/FeaturesList.vue';
    import FeaturesSide from './variations/FeaturesSide.vue';
    import FeaturesWithBackground from './variations/FeaturesWithBackground.vue';
    import FeaturesWithDemo from './variations/FeaturesWithDemo.vue';
    import FeaturesWithImage from './variations/FeaturesWithImage.vue';
    import FeaturesWithVideo from './variations/FeaturesWithVideo.vue';
    import {getSliceVariationComponent} from '../../utils/sliceVariations';

    const props = defineProps(getSliceComponentProps<FeaturesSlice>());

    const variationComponents = {
        default: FeaturesDefault,
        featuresWithBackground: FeaturesWithBackground,
        featuresWithDemo: FeaturesWithDemo,
        featuresWithImage: FeaturesWithImage,
        featuresWithVideo: FeaturesWithVideo,
        featuresSide: FeaturesSide,
        featuresCentred: FeaturesCentred,
        featuresList: FeaturesList,
    };

    const sliceVariationComponent = computed(() => getSliceVariationComponent(props.slice, variationComponents));
</script>
